import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-icon_line_up",
  "use": "icon-icon_line_up-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-icon_line_up\"><path d=\"M748.8 711.04L821.12 638.72l-316.8-316.8v0.064h-0.128l-316.8 316.736 72.448 72.384 244.48-244.416 244.416 244.48z\" p-id=\"2866\" fill=\"#4877F4\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol